import type { Toast, ToastProps } from 'primereact/toast';
import type { RefObject } from 'react';
import type { ToastState } from './notification.types';

const initialState: Partial<ToastState> = {
	toastRef: null,
	toastProps: {
		position: 'bottom-left',
	},
};

export const createToastStore = (
	set: (
		state:
			| Partial<ToastState>
			| ((state: ToastState) => Partial<ToastState>),
	) => void,
) => ({
	...initialState,
	resetState: () => set(initialState),
	setIsHydrated: (isHydrated: boolean) => set({ isHydrated }),
	setToastRef: (ref: RefObject<Toast | null>) => set({ toastRef: ref }),
	setToastProps: (props: Partial<ToastProps>) =>
		set((state) => {
			// Extract pt from props to avoid persisting it
			const { pt, ...persistableProps } = props;
			return {
				toastProps: { ...state.toastProps, ...persistableProps },
			};
		}),
});
